export default __webpack_public_path__ + "static/pole-1-img-f035a98e76c9547da5828c1d30f6503a.png";